import React from 'react';
import { Images, X } from 'lucide-react';
import { useWorkflowStore } from '../../store/workflowStore';

/**
 * NodeMoreInGallery — E6c.5
 *
 * Cartel en el nodo cuando terminaron generaciones que NO son la última
 * mandada: el nodo no las muestra (para no contradecir su prompt actual), pero
 * están guardadas. "Ver" abre la galería.
 */
export const NodeMoreInGallery = ({ nodeId }) => {
  const count = useWorkflowStore((s) => s.galleryNotice[nodeId]);
  const clear = useWorkflowStore((s) => s.clearGalleryNotice);

  if (!count) return null;

  const plural = count === 1 ? 'generación' : 'generaciones';

  return (
    <div
      className="node-more-gallery nodrag"
      onClick={(e) => e.stopPropagation()}
      data-testid={`node-more-gallery-${nodeId}`}
    >
      <Images size={11} />
      <span>Tenés {count} {plural} más en la galería</span>
      <button
        type="button"
        className="nmg-link"
        onClick={() => {
          window.dispatchEvent(new CustomEvent('gallery:open', {
            detail: { nodeId, scope: 'today' },
          }));
          clear(nodeId);
        }}
        data-testid={`node-more-gallery-open-${nodeId}`}
      >
        Ver
      </button>
      <button
        type="button"
        className="nmg-close"
        onClick={() => clear(nodeId)}
        aria-label="Cerrar aviso"
        data-testid={`node-more-gallery-close-${nodeId}`}
      >
        <X size={10} />
      </button>
    </div>
  );
};

export default NodeMoreInGallery;
